export default __webpack_public_path__ + "static/media/blue x details.6362232b.svg";